export default "__VITE_ASSET__DUbFHrZs__"